import ResourceTypes from 'legacy-packages/unit-outline/src/constants';

export const ICON_IDS = {
  EmbeddedVideoResource: 'play_circle',
  PracticeQuestionsResource: 'topic_questions',
  AssessmentResource: 'progress_check',
  URLResource: 'url_resource',
  SourceResource: 'url_resource',
  LTIResource: 'url_resource',
  StudentPracticeResource: 'spp',
};

export const SEARCH_RESOURCE_TYPES_MAP = Object.freeze({
  videos: 'EMBEDDED_VIDEO',
  'progress-checks': 'ASSESSMENT',
  'topic-questions': 'PRACTICE_QUESTIONS',
  'practice-problems': 'SPP',
  sources: 'SOURCE',
  lti: 'LTI',
  more: 'URL',
});

export const PREAP_FILTERS = [
  {
    name: 'All',
    value: '',
    values: [
      'teacher-resources',
      'student-resources',
      'performance-tasks',
      'learning_checkpoint',
      'additional-unit-resources',
    ],
  },
  {
    name: 'Teacher Resources',
    value: 'teacher-resources',
  },
  {
    name: 'Student Resources',
    value: 'student-resources',
  },
  {
    name: 'Assessments',
    value: 'assessments',
  },
  {
    name: 'Additional Unit Resources',
    value: 'additional-unit-resources',
  },
];

export const getFilters = (
  courseOutline = {},
  studentPracticeProblems,
  apSourcesFlag,
  isPreApSubject = false,
) => {
  const filters = [
    {
      name: 'All',
      value: '',
    },
    {
      name: 'Videos',
      value: 'videos',
    },
    {
      name: 'More',
      value: 'more',
    },
  ];

  let withTQs = false;
  let withPPCs = false;
  let breakLoop = false;
  let withSPP = false;
  let withSources = false;

  for (let i = 0; i < courseOutline.units.length; i++) {
    const { subunits } = courseOutline.units[i];

    for (let j = 0; j < subunits.length; j++) {
      const { resources: subunitResources } = subunits[j];

      for (let k = 0; k < subunitResources.length; k++) {
        const resource = subunitResources[k];

        if (resource.__typename === ResourceTypes.PRACTICE_QUESTIONS) {
          withTQs = true;
        }

        if (resource.__typename === ResourceTypes.ASSESSMENT) {
          withPPCs = true;
        }

        if (resource.__typename === ResourceTypes.SPP) {
          withSPP = true;
        }

        if (resource.__typename === ResourceTypes.SOURCE) {
          withSources = true;
        }

        if (resource.__typename === ResourceTypes.LTI) {
          withSources = true;
        }

        breakLoop = withPPCs && withTQs && withSPP && withSources;

        if (breakLoop) {
          break;
        }
      }

      if (breakLoop) {
        break;
      }
    }

    if (breakLoop) {
      break;
    }
  }

  if (withTQs) {
    filters.splice(filters.length - 1, 0, {
      name: 'Topic Questions',
      value: 'topic-questions',
    });
  }

  if (apSourcesFlag && withSources) {
    filters.splice(filters.length - 1, 0, {
      name: 'Sources',
      value: 'sources,lti',
    });
  }

  if (withPPCs) {
    filters.splice(filters.length - 1, 0, {
      name: 'Progress Checks',
      value: 'progress-checks',
    });
  }

  if (withSPP && studentPracticeProblems) {
    filters.splice(filters.length - 1, 0, {
      name: 'Student Practice',
      value: 'practice-problems',
    });
  }

  const filtersToReturn = isPreApSubject ? PREAP_FILTERS : filters;

  return filtersToReturn;
};
